(function() {
    'use strict';

    angular.module('allegro').controller('AccountCreateController', AccountCreateController);

    AccountCreateController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroAccountMessagesConst'
    ];

    function AccountCreateController(
        $scope,
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroAccountMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            nonFieldErrors: [],
            name: [],
            email: [],
        };

        self.accountData = {
            pk: null,
            name: '',
            email: '',
        };

        self.createAccount = createAccount;
        self.cleanErrors = cleanErrors;

        function createAccount() {
            self.loading = true;

            return allegroAccountDataSrvc.create(self.accountData)
                .$promise
                .then(function (response) {
                    self.accountData = response;
                    $state.go('layout.allegro-accounts.detail.overview', {pk: self.accountData.pk});
                    notificationSrvc.notification("success", allegroAccountMessagesConst.create);
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 400) {
                        errorNotificationSrvc.displayErrors(response.data);
                        self.serverErrors = response.data;
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
